export const PROGRESS_LOST = "Lost track of the download. Check your browser's downloads for the file before starting it again.";
export const MAX_RECONNECTS = 5;
export const RECONNECT_DELAY_MS = 2000;

export const parseEvents = (text) => {
    const chunks = text.split('\n\n');
    const rest = chunks.pop();
    const events = chunks.filter((chunk) => chunk.startsWith('data: ')).map((chunk) => JSON.parse(chunk.slice(6)));
    return { events, rest };
};
